import cashBookInstance from '../../cashBook/instance'

const getCashBalance = () => {
	return cashBookInstance.get('/cash-book/new/balance')
}

export default getCashBalance
